import type { ControlDefinition } from './types';

export const STORAGE_KEYS = {
  BATTLEFIELD_HELP: 'dow:onboarding:battlefield-help-v1',
} as const;

export const HELP_TIMING = {
  FIRST_VISIT_DELAY: 1500,
  FADE_IN_DURATION: 250,
  PULSE_DURATION: 1000,
  TOGGLE_DEBOUNCE: 200,
} as const;

export const DESKTOP_CONTROLS: ControlDefinition[] = [
  { key: 'WASD', description: 'Pan camera' },
  { key: 'Scroll', description: 'Zoom in/out', altKey: '+/−' },
  { key: 'Middle-drag', description: 'Pan camera' },
  { key: '?', description: 'Toggle this help', altKey: 'H' },
];

export const MOBILE_CONTROLS: ControlDefinition[] = [
  { key: 'Pinch', description: 'Zoom in/out' },
  { key: 'Drag', description: 'Pan camera' },
  { key: '+/− buttons', description: 'Zoom controls' },
];

export const KEYBOARD_KEYS = {
  TOGGLE: ['?', 'h', 'H'],
  CLOSE: ['Escape'],
  CONTROL: ['w', 'a', 's', 'd', 'W', 'A', 'S', 'D', '+', '-', '='],
} as const;
